import { render, staticRenderFns } from "./AcceptanceList.vue?vue&type=template&id=6e0332e3&"
import script from "./AcceptanceList.vue?vue&type=script&lang=js&"
export * from "./AcceptanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports